{
  "id": "campaign-066",
  "name": "Crooked Green II",
  "seed": "campaign:66",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "...........,",
    ".x.....ooo,,",
    ".....,.oFoss",
    "..q..,,ooo.s",
    ".....,,.....",
    ".W...,.,..W.",
    "..T.T.,T.T..",
    ".....,,.....",
    "....b.,b....",
    "............",
    "............",
    ".W..b..b..W.",
    "............",
    "..q.....#...",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 5,
      "y": 0
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 2
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 9
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    }
  ],
  "generatorVersion": 3,
  "level": 66,
  "biome": "golf",
  "par": {
    "reel": 7574,
    "push": 6130,
    "selfPropelled": 5748,
    "tractor": 4810,
    "zeroTurn": 3861,
    "fairway": 2358
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 22,
      "selfPropelled": 6,
      "tractor": 24,
      "zeroTurn": 4,
      "fairway": 22
    }
  }
}
